import { ComponentPropsWithoutRef } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import PlaceTypeahead from 'components/PlaceTypeahead'

const useStyles = makeStyles((theme) => ({
  place: {
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(4),
      padding: theme.spacing(1, 2),
      width: '100%',
      '& .MuiInputBase-input': {
        paddingLeft: theme.spacing(2),
      },
    },
  },
}))

const PlaceFinder = (props: Omit<ComponentPropsWithoutRef<typeof PlaceTypeahead>, 'TextField'>) => {
  const classes = useStyles()
  return (
    <PlaceTypeahead
      {...props}
      TextField={{
        className: classes.place,
        label: '',
        placeholder: 'Search school name, city, or zip',
      }}
    />
  )
}
export default PlaceFinder
